import { RESET_COMPARISON_SUCCESS } from '../Comparator/Comparator.actions'
import { COMPARATORBIDDINGS, COMPARATORBIDDINGS_SUCCESS, COMPARATORBIDDINGS_ERROR } from './ComparatorBiddings.actions'

const initialState = {
  data: {
    categories: [],
    chart: [],
    csvStructure: []
  },
  fetching: false,
  fetched: false,
  error: null
}

/**
 * Comparator Biddings's reducer.
 */
const comparatorBiddingsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case COMPARATORBIDDINGS: {
      return { ...state, fetching: true }
    }
    case COMPARATORBIDDINGS_SUCCESS: {
      return { ...state, data: payload, fetching: false, fetched: true }
    }
    case COMPARATORBIDDINGS_ERROR: {
      return { ...state, error: payload.error }
    }
    case RESET_COMPARISON_SUCCESS: {
      return initialState
    }
    default: {
      return state
    }
  }
}

export default comparatorBiddingsReducer
